import {
  acme,
  acmeMarketingPageSx,
  acmeMarketingHeadlineSx,
  acmeMarketingSectionTitleSx,
  acmeMarketingBodyLeadSx,
} from '../../theme/acmeTheme';

export const legalPageOuterSx = {
  ...acmeMarketingPageSx,
  width: '100%',
  maxWidth: 900,
  mx: 'auto',
  px: { xs: 2, md: 3 },
  py: { xs: 4, md: 6 },
};

export const legalPageCardSx = {
  boxShadow: 'none',
  border: `1px solid ${acme.colors.border}`,
  borderRadius: acme.radius.lg,
  p: { xs: 3, md: 5 },
  backgroundColor: acme.colors.background,
};

export const legalPageTitleSx = {
  ...acmeMarketingHeadlineSx,
  textAlign: 'center',
  fontSize: { xs: '1.75rem', md: '2.25rem' },
  mb: 1,
  color: acme.colors.foreground,
};

export const legalPageUpdatedSx = {
  ...acmeMarketingBodyLeadSx,
  textAlign: 'center',
  color: acme.colors.mutedForegroundSolid,
  mb: 3,
};

export const legalSectionTitleSx = {
  ...acmeMarketingSectionTitleSx,
  fontSize: { xs: '1.0625rem', md: '1.125rem' },
  mb: 1.5,
  color: acme.colors.foreground,
};

export const legalBodySx = {
  color: acme.colors.mutedForegroundSolid,
  lineHeight: 1.75,
  mb: 2,
  letterSpacing: '-0.022em',
};

export const legalFooterSx = {
  color: acme.colors.mutedForegroundSolid,
  textAlign: 'center',
  fontSize: '0.875rem',
  letterSpacing: '-0.02em',
};
